export function run(){
    return {
        jquery(){
            $(function(){
                $('#nav-icon2').on('click', function(){
                    if(!$(this).hasClass('open')){
                        $('#mobile-menu').addClass('open');
                        setTimeout(() => {
                            $('#mobile-menu ul').addClass('open');
                            $(this).addClass('open');
                        }, 100);
                    }else{
                        $(this).removeClass('open');
                        setTimeout(() => {
                            $('#mobile-menu ul').removeClass('open');
                        }, 200);
                        setTimeout(() => {
                            $('#mobile-menu').removeClass('open');
                        }, 700);
                    }
                });
                $('#mobile-search').on('click', function(){
                    $('#search-vue.search-header').addClass('open');
                });

                $('#search-vue.search-header .fa-times').on('click', function(){
                    $('#search-vue.search-header').removeClass('open');
                });

                $('[data-toggle="tooltip"]').tooltip();
            });
        }
    }
}
